import {TransactionRepository} from "./transaction.repository";
import {TransactionRepositoryV2} from "./transaction.repository.v2";

export type {TransactionRepository} from "./transaction.repository";
export {TransactionRepositoryV2} from "./transaction.repository.v2";

/**
 * Creates the TransactionRepository.
 *
 * V1 has been fully decommissioned; this always returns the v2 implementation.
 *
 * @example
 * const repository = createTransactionRepository();
 * const transactions = await repository.getLocalTransactions({ page: 1, limit: 10 });
 */
export const createTransactionRepository = (): TransactionRepository => {
  return new TransactionRepositoryV2();
};
